import React from 'react';
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {DateCell} from "../../../components/common/advance-table/CustomCells";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import {useUser} from "../../../hooks/useUser";
import NewFacilityIdentifierModal from "./NewFacilityIdentifierModal";
import EditFacilityIdentifierModal from "./EditFacilityIdentifierModal";
import DeleteModal from "../../../components/common/modals/DeleteModal";
import {useTableModals} from "../../../hooks/useTableModals";

const cols = [
    {accessor: 'identifierType.display', Header: 'System'},
    {accessor: 'identifierUseCode.display', Header:'Use'},
    {accessor: 'value', Header: 'Value'},
    {accessor: 'effectiveFrom', Header: "Effective From", Cell: DateCell},
    {accessor:'effectiveTo', Header:'Effective To', Cell: DateCell}
    ];
const FacilityIdentifiers = ({facilityId, identifiers,  allIdentifierTypes, allIdentifierUseCodes}) => {
    const deleteMutation = graphql`
    mutation FacilityIdentifiersDeleteMutation($id: ID!) {
        deleteNode(input: {id: $id}) {
            deletedNodeId @deleteRecord
            owner {
                ... on Facility {
                    id
                    identifiers {
                        id
                    }
                }
            }
        }
    }`
    const data = useFragment(graphql`
        fragment FacilityIdentifiers_Identifiers on FacilityIdentifier @relay(plural:true) {
            id
            identifierType {
                display
                id
            }
            identifierUseCode {
                display
                id
            }
            value
            effectiveFrom
            effectiveTo
        }
    `, identifiers)
    const {hasPermission} = useUser();
    const {selected, columns, newModal, editModal, deleteModal} = useTableModals(cols, "FacilityIdentifier.Update", "FacilityIdentifier.Delete");
    
    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Identifiers"}
                                         table
                                         showNew={hasPermission("FacilityIdentifier.Create")} />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewFacilityIdentifierModal showModal={newModal.showModal}
                                        onClose={newModal.onClose}
                                        identifierTypes={allIdentifierTypes}
                                        identifierUseCodes={allIdentifierUseCodes}
                                        facilityId={facilityId}
            />
            {selected && <EditFacilityIdentifierModal showModal={editModal.showModal}
                                                      onClose={editModal.onClose}
                                                      selectedIdentifier={selected}
                                                      identifierTypes={allIdentifierTypes}
                                                      identifierUseCodes={allIdentifierUseCodes}
            />}
            {selected && <DeleteModal mutation={deleteMutation}
                                      onClose={deleteModal.onClose}
                                      thingToDelete={"Identifier"}
                                      showModal={deleteModal.showModal}
                                      id={selected.id}>
                <p>This action cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
FacilityIdentifiers.propTypes = {}
export default FacilityIdentifiers